import { FooterPhone } from '@app/Layout/Footer/FooterPhone';
import { RecordPhone } from '@modals/RecordPhone';
import { useState } from 'react';
import ClientOnlyPortal from '@sharedComponents/Portal';

import styles from './PhoneBlock.module.scss';

export const PhoneBlock = (): JSX.Element => {
  const [show, setShow] = useState<boolean>(false);
  const handlerShowModal = () => {
    setShow(!show);
    !show ? document.body.classList.add('lock') : document.body.classList.remove('lock');
  };
  return (
    <div className={styles.Container}>
      <FooterPhone />
      <div onClick={handlerShowModal} className={styles.Record}>
        Заказать звонок
      </div>
      {show && (
        <ClientOnlyPortal isOpen={show}>
          <RecordPhone handlerHide={handlerShowModal} />
        </ClientOnlyPortal>
      )}
    </div>
  );
};
